import { DefaultEntity, RoleParams } from '@/types';
import { newQueryKeys } from '@/queries/queryKeys';
import type { RoleDetailQuery } from '@/queries/role.query';
import APIService from './axios.service';
import { BaseService } from './base.service';
import { QueryKeysEnum } from '@/enums';
import { IRole, RoleDetail } from '@/interfaces';
import { QueryFunctionContext } from '@tanstack/react-query';

class RoleService extends BaseService<'role', IRole, DefaultEntity> {
  constructor() {
    super(QueryKeysEnum.ROLE);
  }

  getRoles = (payload: RoleParams): Promise<IRole[]> => {
    return APIService.get(this.path, { params: payload });
  };

  restoreRole = (roleId: string): Promise<IRole> => {
    return APIService.patch(this.path + '/' + roleId + '/restore');
  };

  getRoleDetail = (
    context: QueryFunctionContext<ReturnType<typeof newQueryKeys.role.detail>>,
  ): Promise<RoleDetail> => {
    const { id, query } = context.queryKey[0] as {
      id: string;
      query?: RoleDetailQuery;
    };
    return APIService.get(this.path + '/' + id, { params: query });
  };
}

export const roleService = new RoleService();
